import React from "react";
import { RecoilRoot } from "recoil";
import { QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { ChildrenProp } from "../types";
import { queryClient } from "../services/query";
import { RecoilNexus } from "./RecoilNexus";

const WithStateManagement: React.FC<ChildrenProp> = ({ children }) => {
  React.useEffect(() => {
    if (process.env.REACT_APP_ENABLE_REACT_QUERY_DEVTOOLS) {
      // On mount, sets necessary styles in the head.
      // On unmount, removes them.

      const styles = `
      /* Reset styles that should not apply to the React Query Devtools */
      .ReactQueryDevtoolsPanel * {
        font-size: unset;
        color: unset;
      }
      `;

      const styleElem = document.createElement("style");
      document.head.appendChild(styleElem);
      styleElem.appendChild(document.createTextNode(styles));

      return () => {
        document.head.removeChild(styleElem);
      };
    }

    return () => {
      // Do nothing. There is nothing to clean up here.
    };
  }, []);

  return (
    <RecoilRoot>
      <QueryClientProvider client={queryClient}>
        <RecoilNexus />
        {children}
        {process.env.REACT_APP_ENABLE_REACT_QUERY_DEVTOOLS && (
          <ReactQueryDevtools initialIsOpen={false} />
        )}
      </QueryClientProvider>
    </RecoilRoot>
  );
};

export default WithStateManagement;
